import { render } from "./Guest.vue?vue&type=template&id=6d3eb24c&ts=true"
import script from "./Guest.vue?vue&type=script&lang=ts"
export * from "./Guest.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__